import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { Container, Row, Col, Button, Card, FormText, Dropdown } from "react-bootstrap";
import { logout } from "../../utils";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";

import { DateRangePicker } from "rsuite";
import Select from "react-select";
import moment from "moment/moment";
import { IntegrationReportGrid, ReportModalGrid } from "./IntegrationGrid";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "./IntegrationReport.css"
import Form from "react-bootstrap/Form"
import { Bars } from "react-loader-spinner";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";
import * as Icon from "react-bootstrap-icons";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { TimeRenderer } from "../../reusable-components/Date/TimeRenderer";

import AzureLogsDashboard from './IntegrationDashboard'
import { getFromLS } from "../../utils/storage";

function MaintanenceReports(props) {
  const [firmJobs, setFirmJobs] = useState([]);
  const [selectedFirmJob, setSelectedFirmJob] = useState("");
  const [availableReports, setAvailableReports] = useState([]);
  const [selectedAvailableReports, setSelectedAvailableReports] = useState("");
  // const [reportData, setReportData] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  // const [selectedReport, setSelectedReport] = useState("");
  const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date(Date.now() + 1 * 24 * 60 * 60 * 1000));
  const [reportIsLoading, setReportIsLoading] = useState(false);
  const [exportIsLoading, setExportIsLoading] = useState(false);
  const [clickedInstanceId, setClickedInstanceId] = useState(0);
  const availableFeatures = getFromLS("active-features");
  const [activeTab, setActiveTab] = useState(availableFeatures.includes("FLW_USM") ? "dashboard" : "integration-reports");
  const [generateReport, setGenerateReport] = useState(false);
  const [includeReviewed, setIncludeReviewed] = useState(false);
  const [refreshGrid, setRefreshGrid] = useState(false);
  const [prevSelectedRows, setPrevSelectedRows] = useState(new Set());
  let isReviewedCheckbox = false;

  const [flowOptions, setFlowOptions] = useState([{
    value: "",
    label: "",
    id: "",
  }]);

  const [reportOptions, setReportOptions] = useState([{
    value: "",
    label: "",
    id: "",
  }]);

  const setDate = (val) => {
    setStartDate(val[0]);
    setEndDate(val[1]);
  };

  const [searchText, setSearchText] = useState("")
  const filterText = ({ target: { value } }) => {
    setSearchText(value)
  }

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%", marginTop: 20 }), []);
  const gridStyle = useMemo(() => ({ height: "72vh", minHeight: "100%", width: "100%" }), []);
  // const internalGridStyle = useMemo(() => ({ height: "72vh", minHeight: "100%", width: "100%" }), []);

  // declare default grid params
  const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const [defaultColDef, setDefaultColDef] = useState([{
    headerName: "Reviewed",
    field: "Reviewed",      
    checkboxSelection: true,
    pinned: "left",
    maxWidth: 100,
    cellRenderer: () => ""
  }])
  // TODO: if reviewed is NULL from api - set it as "N" else whatever value it is
  const [internalRowData, setInternalRowData] = useState([]);
  const [internalColDefs, setInternalColDefs] = useState([]);

  const gridRef = useRef();
  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
    const allColumnIds = params.columnApi.getAllColumns().map(col => col.getColId());
    params.columnApi.autoSizeColumns(allColumnIds); // Auto-size all columns
    setRefreshGrid(!refreshGrid);
  }, []);

  // useEffect(() => {
  //   console.log("INTERNAL ROW DATA: ", internalRowData)
  // }, [internalRowData])

  // useEffect(() => {
  //   console.log("INTERNAL COLS DEFS: ", internalColDefs)
  // }, [internalColDefs])

  useEffect(() => {
    if (generateReport) {
      console.log("Both selectedFirmJob and selectedAvailableReports are set, triggering handleButtonClick");
      // Once both states are set, call handleButtonClick
      handleButtonClick();
    }
  }, [generateReport])

  const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };
  
  const GridModal = (gridProps) => {
    // console.log("GRID PROPS: ", gridProps)
    let internalGridApi;
    const onInternalGridReady = useCallback((params) => {
      internalGridApi = params.api;
      internalGridApi.closeToolPanel();
      const allColumnIds = params.columnApi.getAllColumns().map(col => col.getColId());
      params.columnApi.autoSizeColumns(allColumnIds); // Auto-size all columns  
    }, []);

    const Retry = async () => {
      let selectedData = internalGridApi.selectionService.selectedNodes;
      // console.log("SELECTED DATA: ", selectedData)
      if (Object.keys(selectedData).length === 0) {
        // alert("Please select the task/s to retry.")
        toast.error("Please select the task/s to retry.", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toastify-color-success",
        })
      } else {
        // const FlowOrchestratorInstanceId = selectedData[0].data.FlowOrchestratorInstanceId
        const payload = {
          "FlowOrchestratorInstanceLogs": [],
        }
        for (let obj in selectedData) {
          if (Object.keys(selectedData[obj].data["Retry"]).length > 0) {
            payload["FlowOrchestratorInstanceLogs"].push(selectedData[obj].data["FlowOrchestratorInstanceLogId"])
          }
        }

        const data = await makeCygnusApiCall({
          type: "POST",
          payload: payload,
          url: "/retry/integration/",
          show_message: true,
          customized_success_message: "Successfully retry.",
          customized_failure_message: "Unable to retry this integration., please try again. If the problem persists, please contact support and attach a screenshot.",
          customized_error_message: "Error occured while retrying this integration., please contact support and attach a screenshot.",
          isblob: false
        })
        if (data.success) {
          setModalState(false)
          handleButtonClick()
          console.log("Retry response", data);
        }
      }
    };

    const downloadFile = async (which) => {
      let url;
      if (which === 'all') {
        url = `${process.env.REACT_APP_BASE_URI}/workflow/download/report/all/${clickedInstanceId}`;
        toast.info("If you selected all records, the excel will have an additional column: CygnusStatus showing the status of success/failed.", {
          position: "bottom-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toastify-color-info",
        });
      }
      else {
        url = `${process.env.REACT_APP_BASE_URI}/workflow/download/report/failed/${clickedInstanceId}`
      }
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            toast.error("Something went wrong.", {
              position: "bottom-right",
              autoClose: 2500,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              className: "toastify-color-error",
            });
          }
          return;
        }

        // Extract filename from the content-disposition header, if present
        const contentDisposition = response.headers.get('Content-Disposition');
        let fileName = 'exported-file.xlsx'; // Default file name

        if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch.length > 1) {
            fileName = fileNameMatch[1];
          }
        }

        // Download the file
        const blob = await response.blob();
        const urlBlob = window.URL.createObjectURL(blob);

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = urlBlob;
        link.download = fileName; // Use the extracted file name
        document.body.appendChild(link);
        link.click();

        // Clean up the link after the download is triggered
        document.body.removeChild(link);
        window.URL.revokeObjectURL(urlBlob);
      } catch (error) {
        console.error('Error downloading the file:', error);
        toast.error("Something went wrong.", {
          position: "bottom-right",
          autoClose: 2500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: "toastify-color-error",
        });
      }
    };

    return (
      <>
        <Modal
          {...gridProps}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
          centered
          className={"mediummodal"}
        >
          <Modal.Header closeButton className="modal-header-title" style={{ paddingBottom: 0 }}>
            {
              <h6>{modalHeader}</h6>
            }
          </Modal.Header>
          <Modal.Body style={{ paddingTop: 0 }}>
            <Button className={"retry-button"} onClick={Retry}>Retry</Button>&nbsp;&nbsp;&nbsp;
            <div style={{ display: 'inline-block', position: 'relative' }}>

              <Dropdown  >
                <Dropdown.Toggle className="integration-reports-retry-dropdown" variant="primary" id="dropdown-basic">
                  Export to Excel <Icon.Download></Icon.Download>
                </Dropdown.Toggle>

                <Dropdown.Menu >
                  <Dropdown.Item onClick={() => downloadFile('all')} ><Icon.BoxArrowDownRight></Icon.BoxArrowDownRight> All Records</Dropdown.Item>
                  <Dropdown.Item onClick={() => downloadFile('failed')}><Icon.Exclude></Icon.Exclude> Only Failed Records</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <Row className="no-gutter" style={{ marginTop: 20 }}>
              <ReportModalGrid
                rowData={internalRowData}
                colDefs={internalColDefs}
                onGridReady={onInternalGridReady}
              />
            </Row>
          </Modal.Body>
        </Modal>
      </>
    )
  }

  const [modalState, setModalState] = useState(false)
  const [modalHeader, setModalHeader] = useState(false)

  const CustomCellRenderer = (props) => {
    // console.log("CUSTOM CELL RENDERER PROPS: ", props)
    const field = props.colDef.field
    const data = props.data[field]
    let token = localStorage.getItem("token");
    const [apiData, setApiData] = useState([{ "": "" }]);

    const ApiDataSetter = (result) => {
      internalGridParamsMapper(result)
    }

    const showModal = (url) => {
      console.log("url in show modal ", url)
      const parts = url.split('/');
      const id = parts[parts.length - 1];
      setClickedInstanceId(id);
      setModalHeader(data.placeholder)
      makeApiCall(url)
      setTimeout(() => {
        props.modalstate(true)
      }, 2000);
      // console.log("MODAL STATE: ", modalState)

    }
    // THIS IS A CUSTOM API CALL BECAUSE WE GET DATA FOR URL FROM DIFFERENT API
    const makeApiCall = (url) => {
      let requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
      fetch(`${url}`, requestOptions)
        .then((response) => {
          if (!response.ok) {
            if (response.status === 401) {
              // Handle unauthorized error
              logout();
              alert("Session ended , Please login back");
            } else {
              throw new Error("Request failed.");
            }
          }
          return response.json();
        })
        .then((data) => {
          console.log("API DATA : ", data.data.report);
          setApiData(data.data.report);
          return data
        })
        .then((result) => {
          ApiDataSetter(result)
        })
    }

    if (typeof data === 'object') {
      // console.log("CUSTOM CELL RENDERER: ", props)
      if (data.type === "button") {
        return (
          <a href={`${data.url}`} style={{ textDecoration: "none" }}>
            {data.placeholder}
          </a>
        );
      } else if (data.type === "modal") {
        return (
          <>
            <button className="integration-grid-button" style={{ paddingLeft: 10, paddingRight: 10, color: "#000" }} onClick={() => showModal(data.url)}>
              More info
            </button>
          </>
        );
      }
      else {

      }

    } else {
      const isDateField = field.toLowerCase().includes("date");
      let displayData = data;

      if (isDateField && typeof data === "string") {
        displayData = TimeRenderer({ value: data, showTime: true });
      }

      // if (typeof displayData === 'string' && displayData.includes("\\n")) {
      //   console.log("found new line in display data", displayData)
      //   displayData = displayData.replace(/\\n/g, "<br/>");
      //   return <span dangerouslySetInnerHTML={{ __html: displayData }} />
      // }
      if (typeof displayData === 'string' && (displayData.includes('\n') || displayData.includes('\\n'))) {
        const parts = displayData.split(/\\n|\n/); // handle both \n and \\n
        return (
          <span>
            {parts.map((line, idx) => (
              <React.Fragment key={idx}>
                {line}
                {idx < parts.length - 1 && <br />}
              </React.Fragment>
            ))}
          </span>
        );
      }
      
      return (
        <span>
          <span>{displayData}</span>&nbsp;
        </span>
      );
    }

  }

  /**
   * This function is used for formatting the default column names of the grid
   * @param {*} defaultName: Current name from API
   * @returns: Final column name
   */
  const GridColumnTitleRenderer = (defaultName) => {
    const splitWords = defaultName.split("_")
    for (let word in splitWords) {
      splitWords[word] = splitWords[word].charAt(0).toUpperCase() + splitWords[word].slice(1)
    }
    return splitWords.join(" ")
  }

  /**
   * This function takes the API response data and maps it to the grid params
   * @param {*} result: API response
   */
  const gridParamsMapper = (result) => {
    if (result.data.report.length !== 0) {
      const keys = Object.keys(result.data.report[0]);

      const staticColDefsMap = new Map(defaultColDef.map(col => [col.field, col]));
      let jsonColDefs = keys.map(key => {
        if (staticColDefsMap.has(key)) {
          return staticColDefsMap.get(key); 
        }
        return {
          field: key,
          headerName: GridColumnTitleRenderer(key),
          cellRenderer: CustomCellRenderer,
          cellRendererParams: {
            modalstate: setModalState,
          },
          autoHeight: true,
          // cellStyle: { whiteSpace: 'normal', lineHeight: '1.5' },
          cellStyle: {
            // whiteSpace: 'normal',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block',
            // lineHeight: '1.5',
          }
        };
      });
  
      setColDefs(jsonColDefs);
    }  
    setRowData(result.data.report);
  }

  const toggleIncludeReviewed = () => {
    isReviewedCheckbox = true;
    setIncludeReviewed(!includeReviewed);
  };

  const isRowVisible = (params) => {
    if (includeReviewed) {
      return true;
    }
    return !(params.data.Reviewed === "Y");
  };

  const onSelectionChanged = () => {
    if (!gridRef.current || !gridRef.current.api) return;
    const selectedNodes = gridRef.current.api.getSelectedNodes();
    const selectedData = new Set(selectedNodes.map((node) => node.data));

    const newlySelectedRows = Array.from(selectedData).filter(row => !prevSelectedRows.has(row));
    const newlyUnselectedRows = Array.from(prevSelectedRows).filter(row => !selectedData.has(row));
    
    setPrevSelectedRows(selectedData);

    // Skip API calls for initial load
    if (isReviewedCheckbox) {
      isReviewedCheckbox = false;
      return;
    }

    newlySelectedRows.forEach(row => {
      console.log("Selected Row:", row);
      row.Reviewed = "Y";
      updateBackend(row, "selected");
    });

    newlyUnselectedRows.forEach(row => {
      console.log("Unselected Row:", row);
      row.Reviewed = "N";
      updateBackend(row, "unselected");
    });

    setRefreshGrid(!refreshGrid);
  };

  const updateBackend = async (row, action) => {
    console.log(`API Call: Row ${row.InternalId} is now ${action}, Reviewed: ${row.Reviewed}`);
    // console.log("SELECTED ROWS - ", selectedRows)
    const bodyData = {
      FlowOrchestratorInstanceLogId: row?.InternalId,
      Reviewed: row?.Reviewed
    };
    
    console.log(bodyData)
    // call post api 
    const data = await makeCygnusApiCall({
      type: "POST",
      payload: bodyData,
      url: "/report/review/",
      show_message: false,
      customized_success_message: "Review Successfull.",
      customized_failure_message: "Unable to save your Review., please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while saving your Review, please contact support and attach a screenshot.",
      isblob: false
    })

    console.log(data)
  };

  const refreshGridSelection = () => {
    if (gridRef.current && gridRef.current.api) {
      const allRows = gridRef.current.api.getDisplayedRowCount();
      for (let i = 0; i < allRows; i++) {
        const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);
        if (rowNode.data.Reviewed === "Y") {
          rowNode.setSelected(true, false, true);
        }
      }
    }
  };
  
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.onFilterChanged();
      refreshGridSelection();
    }
  }, [refreshGrid, includeReviewed]);

  useEffect(() => {
    setPrevSelectedRows(new Set(rowData.filter(row => row.Reviewed === "Y")));
    setRefreshGrid(!refreshGrid);
  }, [rowData]);
  
  /**
 * This function takes the API response data and maps it to the internal grid params
 * @param {*} result: API response
 */
  const internalGridParamsMapper = (result) => {
    if (result.data.report.length != 0) {
      const keys = Object.keys(result.data.report[0]) // You need to change this based on API response format in every report
      console.log("KEYS: ", keys)
      let jsonColDefs = keys.map(key => {
        return {
          field: key, headerName: GridColumnTitleRenderer(key), cellRenderer: CustomCellRenderer
        }
      });
      jsonColDefs.splice(0, 0, {
        field: "", headerName: '', maxWidth: 20,
        checkboxSelection: true,
      })

      jsonColDefs.splice(jsonColDefs.findIndex(a => a.headerName === "Retry"), 1)
      setInternalColDefs(jsonColDefs)
      // console.log("INTERNAL COL DEFS: ", jsonColDefs)
    }
    setInternalRowData(result.data.report);
    // console.log("INTERNAL ROW DATA: ", result.data.report)
  }

  useEffect(() => {
    const getIntegration = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/status/integration/",
        show_message: false,
        customized_success_message: "Successfully uploaded your K-1 file/s.",
        customized_failure_message: "Unable to fetch your K-1 file/s., please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your K-1 file/s., please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        // console.log("INTEGRATION REPORTS FLOWS", data);
        setFirmJobs(data.data);
        return data.data;
      }
    }
    getIntegration()
  }, []);

  useEffect(() => {
    if (firmJobs.length != 0) {
      const flow_options = firmJobs.map((elem) => {
        return {
          value: elem.FlowName,
          label: elem.FlowName,
          id: elem.FlowOrchestratorId,
        };
      })
      // console.log("FLOW OPTIONS: ", flow_options)
      setFlowOptions(flow_options)
      if (Object.keys(props.reportoption).length === 0) {
        // setSelectedFirmJob(flowOptions[0])
      } else {
        console.log("REPORT OPTIONS FOR PROPS: ", props.reportoption)
        if (flow_options[0].id != "") {
          for (let flow in flow_options) {
            if (flow_options[flow].id == props.reportoption.id) {
              // console.log("ENTERING THE MYFLOW MAPPING DOMAIN: ", flow_options[flow])
              handleFlowSelect(flow_options[flow])
            } else {
              console.log("Do nothing!")
            }
          }
        } else {
          console.log("Do nothing!")
        }

      }
    }
  }, [firmJobs])

  const handleButtonClick = async () => {
    setReportIsLoading(true);
    const finalData = {
      "FlowOrchestratorId": selectedFirmJob.id,
      "StartDate": moment(startDate).utc().format("MM/DD/YYYY"),
      "EndDate": moment(endDate).utc().format("MM/DD/YYYY"),
      "ReportId": selectedAvailableReports.id,
      "SearchText": searchText
    }
    // console.log("FINAL DATA: ", finalData)
    const data = await makeCygnusApiCall({
      type: "POST",
      payload: finalData,
      url: "/status/integration/",
      show_message: true,
      customized_success_message: "Successfull integration.",
      customized_failure_message: "Unable to save your integration., please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while saving your integration, please contact support and attach a screenshot.",
      isblob: false,
      hide_success_message: true
    })
    if (data?.success) {
      setActiveTab("integration-reports");
      setDataSource(data.data.report);
      gridParamsMapper(data)
    }
    setReportIsLoading(false);
    setGenerateReport(false);
  };

  const handleExportButtonClick = async () => {
    setExportIsLoading(true);
    const finalData = {
      "FlowOrchestratorId": selectedFirmJob.id,
      "StartDate": moment(startDate).format("MM/DD/YYYY"),
      "EndDate": moment(endDate).format("MM/DD/YYYY"),
      "ReportId": selectedAvailableReports.id,
      "SearchText": searchText
    }
    console.log("FINAL DATA: ", finalData)
    const data = await makeCygnusApiCall({
      type: "POST",
      payload: finalData,
      url: "/report/export/",
      show_message: true,
      customized_success_message: "Export to Excel Successfull.",
      customized_failure_message: "Export to Excel UnSuccessfull, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while export to excel, please contact support and attach a screenshot.",
      isblob: true
    })

    if(data)
      downloadBlob(data, "report.xlsx");
    
    setExportIsLoading(false);
  };

  const handleFlowSelect = (event) => {
    console.log("FLOW SELECTED: ", event)
    setSelectedFirmJob(event)
    for (let job in firmJobs) {
      if (event.id == firmJobs[job].FlowOrchestratorId) {
        const available_reports = firmJobs[job].ReportNames
        console.log("AVAILABLE REPORTS: ", available_reports)
        setAvailableReports(available_reports)
        if (available_reports.length != 0) {
          const report_options = available_reports.map((elem) => {
            return {
              value: elem.name,
              label: elem.name,
              id: elem.reportId,
            };
          })
          console.log("AVAILABLE REPORTS OPTIONS: ", report_options)
          setReportOptions(report_options)
          //  setSelectedAvailableReports(report_options[0])
        } else {
        }
      } else {
        continue
      }
    }
  }

  const handleReportSelect = (event) => {
    console.log("AVAILABLE REPORTS OPTIONS: ", reportOptions)
    console.log("REPORT SELECTED: ", event)
    setSelectedAvailableReports(event)
  }

  // get grid reference
  let contextGridApi;
  const onContextGridReady = useCallback((params) => {
    contextGridApi = params.api
    contextGridApi.closeToolPanel();
  })

  // Function to receive selected flow data from AzureLogsDashboard
  const handleFlowSelection = (flowId, flowName, status) => {
    console.log("ENTERING AND CALLING A NEW REPORT NOW!!");

    const newFlowOption = { value: flowName, label: flowName, id: flowId};
    handleFlowSelect(newFlowOption)

    // Assuming reportOptions depend on the selected flow
    // setReportOptions([{ value: status, label: `Status: ${status} Report`, id: flowId }]);
    const reportId = status === "Success" ? 0 : 1; 
    handleReportSelect({ value: `${status} Report`, label: `${status} Report`, id: reportId });
    
    setGenerateReport(true);
  };


  return (
    <>
      <Row className="no-gutter recommendation-title-holder">
        <h2 className="display-6">Integration Reports</h2>
      </Row>
      <Row className="no-gutter">
          <Col xs={3} style={{ maxWidth: "22.5%" }}>
            <h6>Flow 
            <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span>
            </h6>
            {firmJobs && (
              <Select
                onChange={handleFlowSelect}
                value={selectedFirmJob}
                // defaultValue={flowOptions[0]}
                placeholder={<div>Select Flow ..</div>}
                options={flowOptions}
                className='custom-select '
                classNamePrefix="react-select"
              />
            )}
          </Col>
          <Col xs={2} style={{ maxWidth: "15%" }}>
            <h6> Select report 
            <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span>
            </h6>
            {availableReports && (
              <Select
                onChange={handleReportSelect}
                value={selectedAvailableReports}
                // defaultValue={reportOptions[0]}
                placeholder={<div>Select report ..</div>}
                options={reportOptions}
                className='custom-select '
                classNamePrefix="react-select"
              />
            )}
          </Col>
          <Col xs={2} style={{ maxWidth: "18.2%" }}>
            <h6> Select Date Range 
            <span style={{ color: 'red', fontSize: '0.8em', verticalAlign: 'super' }}>*</span>
            </h6>
            <DateRangePicker
              defaultValue={[startDate, endDate]}
              format="MM-dd-yyyy"
              // placeholder="start-date to end-date"
              onChange={setDate}
            />
          </Col>
          <Col xs={2} style={{ maxWidth: "12.2%" }}>
            <h6> Search By Text </h6>
            <Form.Control
              type="text"
              onChange={filterText}
              value={searchText}
              className="form-control chat-gpt-input custom-input"
              id=""
              placeholder="Search here"
            />
          </Col>
          <Col xs={2} style={{ maxWidth: "11%" }}>
            <h6> Include Reviewed </h6>
            <input type="checkbox" className={"form-check-input move-left custom-check-input reviewed-checkbox"} 
              checked={includeReviewed} onChange={toggleIncludeReviewed}              
            />
          </Col>
          <Col xs={1} style={{ width: "fit-content" }}>
            <h6>
              &nbsp;
            </h6>
            <CustomButton
              progress={reportIsLoading}
              onclick={() => handleButtonClick()}
              content={reportIsLoading ? "Generating..." : "Generate Report"}
              disable={reportIsLoading 
                || !selectedFirmJob 
                || !selectedAvailableReports 
                || !startDate 
                || !endDate}
              customStyle={{ padding: "10px" }}
            />
          </Col>
          <Col xs={1} style={{ width: "fit-content" }}>
            <h6>
              &nbsp;
            </h6>
            <CustomButton
              progress={exportIsLoading}
              onclick={() => handleExportButtonClick()}
              content={exportIsLoading ? "Exporting..." : "Export to Excel"}
              disable={exportIsLoading 
                || !selectedFirmJob 
                || !selectedAvailableReports 
                || !startDate 
                || !endDate
                || !rowData.length}
              customStyle={{ padding: "10px" }}
            />
          </Col>
        </Row>
      <Row className="no-gutter" style={{paddingLeft: 15, marginTop: 15}}>
      <Tabs
        id="report-dashboard-tabs"
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key)}
        className="mb-3"
      >
      {
        availableFeatures.includes("FLW_USM") &&  
        <Tab eventKey="dashboard" title="Dashboard">
          <AzureLogsDashboard key={activeTab} startDate={startDate} endDate={endDate} onFlowSelect={handleFlowSelection} />
        </Tab>
      }
      <Tab eventKey="integration-reports" title="Integration Reports">
      <GridModal
        show={modalState}
        onHide={() => setModalState(false)}
      />
      <Row className="no-gutter">
        {/* <Col xs={2}></Col> */}
        <Row className="no-gutter">
          <Col md={12}>
            {reportIsLoading ?
              <div className="flex-row-center-center" style={{ marginTop: "20%" }}>
                <div className="spinner flex-column-center-center" style={{ fontSize: 14, fontWeight: 500 }}>
                  <Bars
                    height="80"
                    width="80"
                    color="var(--theme1_primary)"
                    ariaLabel="bars-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                  Loading your data
                </div>
              </div>
              :
              <div style={containerStyle}>
                <div className="ag-theme-balham" style={gridStyle}>
                  <IntegrationReportGrid
                    rowData={rowData}
                    colDefs={colDefs}
                    onGridReady={onGridReady}
                    loadingOverlay={"Loading your report"}
                    rowOverlay={"No data to show, please select / reselect required parameters to generate report"}
                    gridRef={gridRef}
                    isRowVisible={isRowVisible}
                    includeReviewed={includeReviewed}
                    onSelectionChanged={onSelectionChanged}
                  />  
                </div>
              </div>
            }
          </Col>
        </Row>
        {/* <Col xs={2}></Col> */}
      </Row>
      </Tab>
    </Tabs>
    </Row>
    </>
  );
}

export default MaintanenceReports;